import { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";

import { api, cleanAIAnswer, parseArray, robustJsonParse, speakGerman } from "../pureFunctions";
import { Button, Form, Col, Alert, Row, Spinner, Table, ButtonGroup } from "react-bootstrap";
import { header } from "../globalVariables";

import aiIcon from "../img/ki.png";
import editIcon from "../img/edit.png";

import { milieuForm, milieuOutputConfig, milieuPrompt, milieuTexte } from "./MilieuData";
import TextMitZeilennummern from "../Zeilennummern";
import NummerierteSaetze from "../NummerierteSaetze";
import { formatText } from "../formatFunctions";
import { useContextMenu, ContextMenu, getItemsForContext } from "../Utils/ContextMenu";
import MyProgressBar from "../Tools/MyProgressBar";
import { SpinnerGroup } from "../Utils/SpinnerGroup";
import { debouncedSaveEstateData, saveEstateData } from "../networkFunctions";
import LoadingAnimation from "../LoadingAnimation";

const aiModels = ["sonnet-5", "sonnet-5-thinking", "sonnet-5-5", "sonnet-5-5-thinking"];

const textTypes = {
   heading: { heading: "Überschrift", initial: true },
   lage: { heading: "Lagetext", initial: true, maxCount: 450 },
   text: { heading: "Text", initial: true, maxCount: 1450 },
   lage_short: { heading: "Lage (kurz)" },
   text_short: { heading: "Text (kurz)" },
   // long: { heading: "Text (Langversion)" },
};

const tabs = {
   milieu: "Milieu",
   places: "Umgebung",
};

const initialMilieu = { options: {}, result: {}, selected: "selbstständig erkennen" };

export default function AIExpo({ estateId, eskstatus, data, kacheln, fieldconfiguration, selectExpo, user }) {
   const [playAudio, setPlayAudio] = useState(false);
   const [currentTab, setCurrentTab] = useState("milieu");

   const [selectedModel, setSelectedModel] = useState("sonnet-5-5");

   const [show, setShow] = useState(false);
   const [conversations, setConversations] = useState({});

   const promptRef = useRef(null);
   const containerRef = useRef(null);
   const bottomRef = useRef(null);
   const [placesData, setPlacesData] = useState();

   const [aiLoading, setAiLoading] = useState(() =>
      Object.keys(textTypes).reduce((oldObj, item) => ({ ...oldObj, [item]: false }), {}),
   );

   const [prompt, setPrompt] = useState({});

   const [milieuData, setMilieuData] = useState(initialMilieu);

   const handleClose = () => {
      setShow(false);
   };
   const handleShow = async () => {
      setShow(true);
      await initializeData();
   };

   useEffect(() => {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
   }, [conversations]);

   function getCleanData() {
      let myData = [];
      kacheln.datenblatt.kachel.forEach((element) => {
         /*  console.log(element.kachelId);
         console.log(eskstatus["kachel_status_" + element.kachelId]); */
         if (eskstatus["kachel_status_" + element.kachelId] < 10) {
            myData.push(...element.fields.flat());
         }
      });
      kacheln.vollmacht.kachel.forEach((element) => {
         if (eskstatus["kachel_status_" + element.kachelId] < 10) {
            myData.push(...element.fields.flat());
         }
      });

      console.log(data);
      console.log(eskstatus);

      let cleanData = Object.fromEntries(
         myData
            .map((item) => {
               let readableData;
               // console.log(item);

               let plainData = data[item.name] && data[item.name] !== "⠀" ? data[item.name] : "";

               if (plainData) {
                  if (item.onOffice) {
                     if (Array.isArray(plainData)) {
                        readableData = plainData
                           .map((dataItem) => fieldconfiguration[item.module][item.name].permittedvalues[dataItem])
                           .join(",");
                     } else if (item.type === "singleselect") {
                        readableData = fieldconfiguration[item.module][item.name].permittedvalues[plainData];
                     } else if (item.type === "boolean") {
                        readableData = plainData === "1" ? "Ja" : "";
                     } else {
                        readableData = plainData;
                     }
                  } else {
                     readableData = plainData;
                  }
               }
               return [item.heading, { data: readableData, importance: item.ai ?? 0 }];
            })
            .filter((item) => item[1]?.data !== undefined && item[1]?.importance > 0),
      );

      console.log(cleanData);

      return cleanData;
   }

   async function generateMilieu() {
      setAiLoading((prev) => ({ ...prev, milieu: "loading" }));
      const cleanData = getCleanData();
      // return false;
      let finalPrompt = milieuPrompt.replace(
         "$DATEN",
         JSON.stringify({ milieuDaten: milieuData, objektDaten: cleanData }, null, 2),
      );

      const content = await api
         .post(
            `api/ai_prompt`,
            {
               model: selectedModel,
               prompt: finalPrompt,
               outputConfig: milieuOutputConfig,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            console.log(data?.data?.content);

            return robustJsonParse(data?.data?.content ?? data?.content);
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
            setAiLoading((prev) => ({ ...prev, milieu: "error" }));
         });

      console.log(content);

      changeMilieuData("result", content);
      setAiLoading((prev) => ({ ...prev, milieu: false }));
   }

   async function generateInitialText(type) {
      setAiLoading((prev) => ({ ...prev, [type]: "loading" }));

      const newTextResp = await api
         .post(
            `/api/ai/generateTexts`,
            {
               estateData: getCleanData(),
               placesData: placesData,
               milieuData: milieuData.selected,
               conversationKey: type,
               model: selectedModel,
               estateId: estateId,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            return data.data;
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
            setAiLoading((prev) => ({ ...prev, [type]: "error" }));
         });
      setConversations((prev) => ({ ...prev, [type]: newTextResp }));

      setAiLoading((prev) => ({ ...prev, [type]: false }));
   }

   async function generateShortText(prevType, lastResponse, charCount) {
      const type = prevType + "_short";
      setAiLoading((prev) => ({ ...prev, [type]: "loading" }));
      const newMessage =
         `Generiere aus dem Text eine Kurzversion mit maximal $CHARCOUNT Zeichen. Versuche dabei so viele Fakten wie möglich zu erhalten. Füge keine neuen Informationen hinzu.`.replace(
            "$CHARCOUNT",
            charCount,
         );
      const messages = structuredClone(conversations[prevType]).slice(0, 4);

      messages.push({ role: "assistant", content: lastResponse, user: user.Name, t: new Date(), hidden: true });
      messages.push({ role: "user", content: newMessage, user: user.Name, t: new Date(), hidden: true });

      console.log(messages);

      // return 0;

      const newTextResp = await api
         .post(
            `/api/ai/handle-conversation`,
            {
               messages,
               conversationKey: type,
               model: selectedModel,
               estateId: estateId,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            return data.data;
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
            setAiLoading((prev) => ({ ...prev, [type]: "error" }));
         });
      setConversations((prev) => ({ ...prev, [type]: newTextResp }));

      setAiLoading((prev) => ({ ...prev, [type]: false }));
   }
   async function selectTextOption(type, selectedText) {
      const updatedConversations = structuredClone(conversations);
      updatedConversations[type].push({
         role: "user",
         content: `Nutze diese Variante für alle weiteren Anfragen: **${selectedText}** und gib ab jetzt nur den reinen Text ohne Markdown, JSON oder sonstige Hinweise zurück. Verändere zukünftig nur die Punkte die angesprochen werden und lasse den restlichen Text so wie er ist.`,
         user: user.Name,
         t: new Date(),
         hidden: true,
      });
      updatedConversations[type].push({
         role: "assistant",
         content: selectedText,
         user: user.Name,
         t: new Date(),
         hidden: false,
      });

      setConversations(updatedConversations);

      saveEstateData({ aiConversations: updatedConversations }, estateId);

      /*   */
   }

   async function generateText(type, newMessage) {
      setAiLoading((prev) => ({ ...prev, [type]: "loading" }));
      const messages = [...structuredClone(conversations[type]), newMessage];
      const newTextResp = await api
         .post(
            `/api/ai/handle-conversation`,
            {
               messages,
               conversationKey: type,
               model: selectedModel,
               estateId: estateId,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            return data.data;
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
            setAiLoading((prev) => ({ ...prev, [type]: "error" }));
         });
      setConversations((prev) => ({ ...prev, [type]: newTextResp }));

      setAiLoading((prev) => ({ ...prev, [type]: false }));
   }

   async function getData() {
      try {
         console.log(estateId);

         const data = await api.get(`api/ip/estateData`, {
            params: {
               estateId: estateId,
               reqData: ["estateId", "lat", "lon", "address", "places", "milieu", "aiConversations", "updatedAt"],
            },
            ...header,
         });
         console.log(data);
         if (data?.data?.places?.places) {
            setPlacesData(data.data.places.places);
         } else {
            const googleData = await getGooglePlaces();
            console.log(googleData);
            setPlacesData(googleData);
         }

         setMilieuData(data?.data?.milieu ?? initialMilieu);

         setConversations(data?.data?.aiConversations ?? {});
      } catch (err) {
         console.log(err);
      }
   }

   async function initializeData() {
      setAiLoading({ all: true });
      await getData();
   }

   async function getGooglePlaces() {
      console.log({
         estateId: estateId,
         strasse: data.strasse,
         hausnummer: data.hausnummer,
         plz: data.plz,
         ort: data.ort,
         lat: data.breitengrad,
         lon: data.laengengrad,
      });

      const newGoogleResp = await api
         .post(
            `api/googleEstatePlaces`,
            {
               estateId: estateId,
               strasse: data.strasse,
               hausnummer: data.hausnummer,
               plz: data.plz,
               ort: data.ort,
               lat: data.breitengrad,
               lon: data.laengengrad,
            },
            header,
         )
         .then((data) => {
            console.log(data);
            return data.data;
         })
         .catch((err) => {
            console.log(err);
            console.log(err.error);
         });

      return newGoogleResp;
   }

   function changeMilieuData(type, value, key) {
      let updatedMilieuData = structuredClone(milieuData);
      if (type === "options") {
         if (!Array.isArray(updatedMilieuData[type][key])) {
            updatedMilieuData[type][key] =
               updatedMilieuData[type][key] !== undefined ? [updatedMilieuData[type][key]] : [];
         }
         if (updatedMilieuData[type][key].includes(value)) {
            updatedMilieuData[type][key] = updatedMilieuData[type][key].filter((item) => item !== value);
         } else {
            updatedMilieuData[type][key].push(value);
         }
      } else if (type === "result") {
         updatedMilieuData[type] = value;
         updatedMilieuData.selected = value.primaerMilieu;
      } else if (type === "selected") {
         updatedMilieuData[type] = value;
      }
      setMilieuData(updatedMilieuData);
      debouncedSaveEstateData({ milieu: updatedMilieuData }, estateId);
   }

   function changePlacesData(katIndex, objIndex, importance) {
      let updatedPlacesData = structuredClone(placesData);
      updatedPlacesData[katIndex].objekte[objIndex]["importance"] = importance;
      setPlacesData(updatedPlacesData);
      debouncedSaveEstateData({ places: updatedPlacesData }, estateId);
   }

   async function handleSendPrompt(type) {
      await generateText(type, {
         role: "user",
         content: prompt[type],
         user: user.Name,
         t: new Date(),
         hidden: false,
      });
      setPrompt((prev) => ({
         ...prev,
         [type]: "",
      }));
      // promptRef.current?.focus()
      // bottomRef.current?.scrollIntoView({ behavior: "smooth" });
   }

   return (
      <>
         <div style={{ position: "relative" }}>
            <button
               onClick={() => {
                  handleShow();
               }}
               className="custom-button"
               style={{
                  position: "absolute",
                  width: "56px",
                  right: "180px",
                  zIndex: 0,
               }}
               title="Expo-Texte generieren"
            >
               <img src={aiIcon} />
            </button>
         </div>

         <Modal show={show} onHide={handleClose} dialogClassName="xxl-modal">
            <Modal.Header closeButton>
               <Modal.Title>Expo-Text-Generator</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <ul className="nav nav-tabs mb-2">
                  {Object.keys(tabs).map((tabKey, index) => (
                     <li className="nav-item" key={tabKey}>
                        <button
                           style={{
                              height: "60px",
                              marginBottom: "-2px",
                              fontWeight: 700,
                              color: "#047",
                           }}
                           className={"nav-link" + (currentTab === tabKey ? " active" : "")}
                           name={tabKey}
                           aria-current="page"
                           onClick={(e) => {
                              setCurrentTab(e.target.name);
                           }}
                        >
                           {tabs[tabKey]}
                        </button>
                     </li>
                  ))}
                  {Object.keys(conversations).map((conversationKey) => {
                     return (
                        <li className="nav-item" key={"tab_" + conversationKey}>
                           <button
                              style={{
                                 height: "60px",
                                 marginBottom: "-2px",
                                 fontWeight: 900,
                                 color: "#047",
                              }}
                              className={"nav-link" + (currentTab === conversationKey ? " active" : "")}
                              aria-current="page"
                              onClick={(e) => {
                                 setCurrentTab(conversationKey);
                              }}
                           >
                              {textTypes[conversationKey]?.heading}
                              {aiLoading[conversationKey] === "loading" && (
                                 <Spinner className="mx-1" size="sm" animation="grow"></Spinner>
                              )}
                           </button>
                        </li>
                     );
                  })}

                  <li className=" ms-2">
                     <Button
                        style={{
                           height: "50px",
                           marginBottom: "-2px",
                           fontWeight: 500,
                           background: "#047",
                        }}
                        aria-current="page"
                        onClick={async (e) => {
                           for (const key in textTypes) {
                              if (textTypes[key].initial) {
                                 generateInitialText(key);
                              }
                           }
                        }}
                     >
                        Alle Texte {conversations ? "neu" : ""} generieren
                        {Object.values(aiLoading)
                           .filter((item) => item === "loading")
                           .map((item, index) => {
                              return (
                                 <Spinner
                                    key={"aiLoader_" + index}
                                    className="mx-1"
                                    size="sm"
                                    animation="grow"
                                 ></Spinner>
                              );
                           })}
                     </Button>
                  </li>
                  <li>
                     <Form.Group className="m-1">
                        {/* <Form.Label>
                                                     Model
                                                   </Form.Label> */}
                        <Form.Select
                           onChange={(e) => {
                              setSelectedModel(e.target.value);
                           }}
                           value={selectedModel}
                        >
                           {aiModels.map((item) => {
                              return <option value={item}>{item}</option>;
                           })}
                        </Form.Select>
                     </Form.Group>
                  </li>
               </ul>

               {currentTab === "milieu" && (
                  <>
                     {milieuData.result?.primaerMilieu && (
                        <Alert className="my-2 p-4">
                           <h3>Ergebnis:</h3>
                           <Alert>
                              <h4>
                                 Primärmilieu: {milieuData.result.primaerMilieu}{" "}
                                 <small>(Konfidenz: {milieuData.result.konfidenz} %)</small>
                              </h4>
                              <h5>
                                 Sekundärmilieu: {milieuData.result.sekundaerMilieu}{" "}
                                 <small>(Konfidenz: {milieuData.result.sekundaerKonfidenz} %)</small>
                              </h5>
                              <ul>
                                 {milieuData.result?.begruendung?.map((item) => (
                                    <li key={item}>{item}</li>
                                 ))}
                              </ul>
                           </Alert>
                           <ButtonGroup>
                              <Button
                                 variant={
                                    "outline-primary " +
                                    (milieuData.selected === milieuData.result.primaerMilieu ? "active" : "")
                                 }
                                 title={milieuTexte?.[milieuData.result.primaerMilieu]?.text}
                                 onClick={() => {
                                    changeMilieuData("selected", milieuData.result.primaerMilieu);
                                 }}
                              >
                                 {milieuData.result.primaerMilieu} auswählen
                              </Button>
                              <Button
                                 title={milieuTexte?.[milieuData.result.sekundaerMilieu]?.text}
                                 variant={
                                    "outline-primary " +
                                    (milieuData.selected === milieuData.result.sekundaerMilieu ? "active" : "")
                                 }
                                 onClick={() => {
                                    changeMilieuData("selected", milieuData.result.sekundaerMilieu);
                                 }}
                              >
                                 {milieuData.result.sekundaerMilieu} auswählen
                              </Button>
                           </ButtonGroup>
                           <ButtonGroup className="mt-2">
                              {Object.keys(milieuTexte)
                                 .filter(
                                    (item) =>
                                       ![milieuData.result.primaerMilieu, milieuData.result.sekundaerMilieu].includes(
                                          item,
                                       ),
                                 )
                                 .map((item) => {
                                    return (
                                       <Button
                                          key={item}
                                          variant={
                                             "outline-secondary " + (milieuData.selected === item ? "active" : "")
                                          }
                                          title={milieuTexte?.[item]?.text}
                                          onClick={() => {
                                             changeMilieuData("selected", item);
                                          }}
                                       >
                                          {item}
                                       </Button>
                                    );
                                 })}
                           </ButtonGroup>
                        </Alert>
                     )}
                     <MyProgressBar
                        rounded
                        color="#333"
                        value={
                           100 *
                           (Object.values(milieuData.options).filter((item) => item).length /
                              Object.values(milieuForm).length)
                        }
                     />
                     <div
                        style={{
                           maxHeight: "70vh",
                           overflow: "auto",
                           scrollbarColor: "#ccc transparent",
                           scrollbarWidth: "thin",
                        }}
                     >
                        <Form className="mx-0" style={{ width: "calc( 100% - 20px)" }}>
                           <Row>
                              {milieuForm.map((milieuItem, index) => {
                                 return (
                                    <Col key={"milieuform_" + index} md={milieuItem.width ?? 12} sm={12}>
                                       <Form.Group
                                          controlId={"milieuitem_" + index}
                                          className="mb-2 mt-2"
                                          style={{
                                             padding: "20px",
                                             boxShadow: "inset 0 0 8px #ccc",
                                             borderRadius: "20px",
                                             borderLeft: milieuData?.options?.[milieuItem.name]
                                                ? ""
                                                : "solid 14px #b00",
                                          }}
                                       >
                                          <Form.Label>{milieuItem.heading}:</Form.Label>

                                          {milieuItem.options && (
                                             <ButtonGroup
                                                className="w-100 "
                                                vertical
                                                style={{ /* boxShadow: "0 0 6px #0003", */ borderRadius: "10px" }}
                                             >
                                                {milieuItem.options.map((option, index2) => (
                                                   <Button
                                                      className={
                                                         "text-start " +
                                                         (milieuData?.options?.[milieuItem.name]?.includes(option)
                                                            ? " active"
                                                            : "")
                                                      }
                                                      variant="light"
                                                      key={index + "option_" + index2}
                                                      onClick={() => {
                                                         changeMilieuData("options", option, milieuItem.name);
                                                      }}
                                                   >
                                                      • {option}
                                                   </Button>
                                                ))}
                                             </ButtonGroup>
                                          )}
                                          {milieuItem.textarea && (
                                             <Form.Control
                                                as="textarea"
                                                placeholder=""
                                                onChange={(e) => {
                                                   changeMilieuData("options", e.target.value, milieuItem.name);
                                                }}
                                                name={milieuItem.name}
                                                value={milieuData?.options?.[milieuItem.name]}
                                                style={{ minHeight: "115px", fieldSizing: "content" }}
                                             />
                                          )}
                                       </Form.Group>
                                    </Col>
                                 );
                              })}
                           </Row>
                        </Form>
                     </div>

                     <Button
                        className="my-2 w-100"
                        style={{ background: "#047" }}
                        disabled={
                           aiLoading?.milieu === "loading" ||
                           (() => {
                              return !milieuForm.every((item) => milieuData?.options[item.name]);
                           })()
                        }
                        onClick={() => {
                           generateMilieu();
                        }}
                     >
                        {aiLoading?.milieu === "loading" ? <LoadingAnimation /> : <span>Milieu ermitteln</span>}
                     </Button>
                  </>
               )}
               {currentTab === "places" && (
                  <>
                     <Button
                        className="my-2 w-100"
                        variant={placesData ? "outline-dark" : "primary"}
                        onClick={async () => {
                           const googleData = await getGooglePlaces();
                           console.log(googleData);
                           setPlacesData(googleData);
                        }}
                     >
                        Lagedaten {placesData ? "neu laden" : "laden"}
                     </Button>
                     <div
                        style={{
                           maxHeight: "70vh",
                           overflow: "auto",
                           scrollbarColor: "#ccc transparent",
                           scrollbarWidth: "thin",
                        }}
                     >
                        <Form className="mx-0" style={{ width: "calc( 100% - 20px)" }}>
                           {placesData &&
                              placesData.map((kat, katIndex) => {
                                 return (
                                    <Row key={kat.key ?? katIndex}>
                                       <Col md={12} sm={12}>
                                          <Form.Group
                                             controlId={"placeitem_" + katIndex}
                                             className="mb-2 mt-2"
                                             style={{
                                                padding: "20px",
                                                boxShadow: "inset 0 0 8px #ccc",
                                                borderRadius: "20px",
                                             }}
                                          >
                                             <Form.Label>{kat.label}:</Form.Label>
                                             <ButtonGroup
                                                className="w-100 "
                                                vertical
                                                style={{ /* boxShadow: "0 0 6px #0003", */ borderRadius: "10px" }}
                                             >
                                                {kat.objekte.map((obj, objIndex) => (
                                                   <Button
                                                      variant="light"
                                                      className={"text-start " + (obj.importance ? "active" : "")}
                                                      onClick={() => {
                                                         changePlacesData(katIndex, objIndex, obj.importance ? 0 : 10);
                                                      }}
                                                      key={`${kat.key}-${objIndex}`}
                                                   >
                                                      <strong title={obj.name}>{obj.name}</strong>
                                                      <small className="mx-1" title={obj.typ}>
                                                         ({obj.typ})
                                                      </small>
                                                      <span className="mx-1">Distanz: {obj.distanz}m</span>
                                                      {obj.bewertung && (
                                                         <span className="mx-1">
                                                            <strong>{obj.bewertung}⭐</strong>
                                                            <small className="">({obj.anzahlBewertungen})</small>
                                                         </span>
                                                      )}
                                                   </Button>
                                                ))}
                                             </ButtonGroup>
                                          </Form.Group>
                                       </Col>
                                    </Row>
                                 );
                              })}
                        </Form>
                     </div>
                  </>
               )}

               {conversations?.[currentTab] && (
                  <>
                     <div className="m-2">
                        <div
                           style={{
                              padding: "2px 4px",
                              background: "#fff",
                              color: "#000",
                              width: "100%",
                              borderRadius: "14px",
                              // border: "solid 1px #eee",
                              background: "#ddd",
                           }}
                        >
                           {aiLoading[currentTab] === "loading" && !(conversations?.[currentTab]?.length > 2) ? (
                              <div
                                 style={{
                                    textAlign: "center",
                                    margin: "2px 0px",
                                    padding: "14px 2px",
                                    background: "#fff",
                                    color: "#000",
                                    width: "100%",
                                    borderRadius: "10px",
                                    background: "#fff",
                                 }}
                              >
                                 <SpinnerGroup />
                              </div>
                           ) : (
                              <>
                                 {textTypes?.[currentTab]?.initial && (
                                    <Button
                                       className="w-100 my-1"
                                       variant="dark"
                                       onClick={async (e) => {
                                          await generateInitialText(currentTab);
                                       }}
                                    >
                                       Neu starten
                                    </Button>
                                 )}

                                 <div
                                    // ref={containerRef}
                                    style={{
                                       background: "#ddd",
                                       border: "solid 4px #ddd",
                                       margin: "10px 0px",
                                       padding: "10px 30px",
                                       maxHeight: "50vh",
                                       overflow: "auto",
                                       borderRadius: "10px",
                                       scrollbarColor: "#fffc transparent",
                                       scrollbarWidth: "thin",
                                    }}
                                 >
                                    {conversations?.[currentTab].map((item, index) => {
                                       let parsedContent;
                                       if (!item.hidden) {
                                          if (Array.isArray(item.content)) {
                                             parsedContent = [...item.content];
                                          } else {
                                             parsedContent = item.content && parseArray(cleanAIAnswer(item.content));
                                          }
                                       }

                                       if (!item.hidden)
                                          return (
                                             <div
                                                key={"prompttext" + currentTab + index}
                                                style={{ position: "relative" }}
                                             >
                                                <div
                                                   style={{
                                                      border: "solid 0px #026",
                                                      // boxShadow: "6px 6px 2px #0006",

                                                      margin: "16px",
                                                      padding: "10px 20px",
                                                      whiteSpace: "pre-wrap",
                                                      ...(item.role === "user"
                                                         ? {
                                                              borderRadius: "20px 20px 0px 20px",
                                                              background: "#333",
                                                              color: "#fff",
                                                              marginRight: "0px",
                                                           }
                                                         : item.role === "system"
                                                           ? {
                                                                borderRadius: "20px",
                                                                background: "#047",
                                                                color: "#fff",
                                                                marginRight: "0px",
                                                                maxHeight: "500px",
                                                                overflow: "auto",
                                                             }
                                                           : {
                                                                marginLeft: "0px",
                                                                borderRadius: "20px 20px 20px 0",
                                                                background: "#fff",
                                                             }),
                                                   }}
                                                >
                                                   <>
                                                      {item.role === "assistant" &&
                                                         parsedContent.length &&
                                                         parsedContent.map((arrayText) => {
                                                            return (
                                                               <div key={arrayText} className="ai-text-button">
                                                                  <div
                                                                     className="text-start"
                                                                     style={{ whiteSpace: "pre-wrap" }}
                                                                  >
                                                                     {arrayText}
                                                                     {item.role === "assistant" && (
                                                                        <div
                                                                           style={{
                                                                              fontSize: "small",
                                                                              background: "#333",
                                                                              color: "#fff",
                                                                              padding: "2px 10px",
                                                                              width: "fit-content",
                                                                           }}
                                                                        >
                                                                           {cleanAIAnswer(arrayText)?.length}
                                                                        </div>
                                                                     )}
                                                                  </div>
                                                                  <div className="ai-edit">
                                                                     {parsedContent.length > 1 &&
                                                                        index ===
                                                                           conversations?.[currentTab].length - 1 && (
                                                                           <Button
                                                                              className="mx-1 w-25"
                                                                              variant="light"
                                                                              onClick={async () => {
                                                                                 selectTextOption(
                                                                                    currentTab,
                                                                                    arrayText,
                                                                                 );
                                                                                 // await generateText(currentTab,arrayText);
                                                                              }}
                                                                           >
                                                                              Auswählen
                                                                           </Button>
                                                                        )}
                                                                     <Button
                                                                        className="mx-1 w-25"
                                                                        variant="light"
                                                                        onClick={() => {
                                                                           if (playAudio) {
                                                                              window.speechSynthesis.cancel();
                                                                              setPlayAudio(false);
                                                                           } else {
                                                                              speakGerman(arrayText, setPlayAudio);
                                                                           }
                                                                        }}
                                                                     >
                                                                        {playAudio ? "⏹" : "▶"}
                                                                     </Button>
                                                                     <Button
                                                                        className="mx-1 w-25"
                                                                        variant="light"
                                                                        onClick={async () => {
                                                                           await navigator.clipboard.writeText(
                                                                              arrayText,
                                                                           );
                                                                        }}
                                                                     >
                                                                        Kopieren
                                                                     </Button>
                                                                     {["text", "lage"].includes(currentTab) && (
                                                                        <Button
                                                                           className="mx-1 w-25"
                                                                           variant="light"
                                                                           onClick={async () => {
                                                                              await generateShortText(
                                                                                 currentTab,
                                                                                 arrayText,
                                                                                 currentTab === "text" ? 1450 : 450,
                                                                              );
                                                                           }}
                                                                        >
                                                                           Kurztext generieren
                                                                        </Button>
                                                                     )}
                                                                     {/*  <Button
                                                                        className="mx-1 w-25"
                                                                        variant="light"
                                                                        onClick={async () => {
                                                                           await generateShortText(
                                                                              currentTab,
                                                                              arrayText,
                                                                              currentTab === "text" ? 1450 : 450,
                                                                           );
                                                                        }}
                                                                     >
                                                                        Text nutzen
                                                                     </Button> */}
                                                                     {/* extx_lg_sh */}
                                                                  </div>
                                                               </div>
                                                            );
                                                         })}
                                                      {item.role === "user" && <span>{parsedContent}</span>}
                                                   </>
                                                </div>
                                                <div
                                                   style={{
                                                      bottom: -10,
                                                      position: "absolute",
                                                      color: "#fff",
                                                      borderRadius: "100px",
                                                      width: "26px",
                                                      height: "26px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      ...(item.role === "assistant"
                                                         ? { left: -30, background: "#000" }
                                                         : { right: -30, background: "#047" }),
                                                   }}
                                                >
                                                   {item.role === "assistant" ? (
                                                      "A"
                                                   ) : (
                                                      <span title={item.user + " " + item.t}>{item.user[0]}</span>
                                                   )}
                                                </div>
                                             </div>
                                          );
                                    })}
                                    <div ref={bottomRef} />
                                 </div>
                                 <Form>
                                    <Row className="mb-0">
                                       <Form.Group as={Col} controlId={"id_prompt"} className="m-2 mb-0">
                                          <Form.Control
                                             as="textarea"
                                             ref={promptRef}
                                             // disabled={aiLoading[currentTab] === "loading"}
                                             placeholder="Nachricht schreiben ..."
                                             onChange={(e) => {
                                                setPrompt((prev) => ({
                                                   ...prev,
                                                   [currentTab]: e.target.value,
                                                }));
                                             }}
                                             onKeyDown={(e) => {
                                                if (e.key === "Enter" && e.shiftKey) {
                                                   e.preventDefault(); // verhindert Zeilenumbruch im Textarea
                                                   handleSendPrompt(currentTab);
                                                }
                                             }}
                                             value={prompt?.[currentTab] ?? ""}
                                             style={{
                                                borderRadius: "10px 10px 0 0",
                                                minHeight: "80px",
                                                fieldSizing: "content",
                                                border: "3px solid #0003",
                                                borderBottom: "none",
                                             }}
                                          ></Form.Control>
                                       </Form.Group>
                                    </Row>
                                    <Row>
                                       <Col className="mx-2 mb-2">
                                          <Button
                                             variant="primary"
                                             style={{ background: "#047", borderRadius: "0 0 10px 10px" }}
                                             className="w-100 p-2"
                                             disabled={aiLoading[currentTab] === "loading" || !prompt[currentTab]}
                                             onClick={() => {
                                                handleSendPrompt(currentTab);
                                             }}
                                          >
                                             {aiLoading[currentTab] === "loading" ? <LoadingAnimation /> : "➡"}
                                          </Button>
                                       </Col>
                                    </Row>
                                 </Form>
                              </>
                           )}
                        </div>
                     </div>
                  </>
               )}
               <div className="mt-1"></div>
            </Modal.Body>
         </Modal>
      </>
   );
}
